<template lang="pug">
.menu-top
  transition(name="slide-left")
    .menu.column(v-if="show" v-touch:swipe.horizontal="close")
      .header.column(@click.stop)
        .title {{ $root.user.name.titleize() }}
        .subtitle {{ $root.user.email }}
      .item(@click="$root.modal = { name: 'account'}") {{ t.change_box }}
      template(v-if="$root.admin || $root.community_manager")
        .item(@click.stop="update_query({ archived: !$route.query.archived });$emit('close');") {{ $route.query.archived ? t.hide_archived : t.show_archived }}
        .item(@click.stop="$router.push('/users')") {{ t.users }}
        .item(@click.stop="$router.push('/accounts')") {{ t.accounts }}
        .item(@click.stop="$root.admin_modal = {name: 'edit_account', data: $root.active_account}") {{ t.modify_account }}
        //- .item(@click.stop="$root.modal = {name: 'email'}") {{ t.send_notification }}
      .item(@click.stop="reset_password") {{ t.reset_password }}
      .item.row.between(@click.stop="$root.change_notification($root.user_id)")
        div {{ $root.user.notification ? t.disable_notifications : t.enable_notifications}}
        .icon(:class="{disabled: !$root.user.notification}")
          font-awesome-icon(icon="envelope")
      .item.row.between(@click.stop="$root.change_lang")
        div {{ t.change_lang }}
        svg-icon(:name="($root.lang === 'fr') ? 'flag-en' : 'flag-fr'")
      .item.row.between(@click.stop="$root.logout")
        div {{ t.disconnect }}
        .icon
          font-awesome-icon(icon="sign-out-alt")

  .hidden-backdrop(v-if="show" @click.stop="close")
  .modal(v-if="reset" @click.stop)
    .column.center(v-if="reset === 'success'")
      div {{ t.reset_email_sent }} {{ $root.user.email }}
      button.primary(@click.stop="close" style="color: white; min-width: 100px; margin-top: 8px;") OK
    .colum.center(v-else)
      div {{ t.loading }}
</template>
<script>
export default {
  props: ['show'],
  data() {
    return {
      reset: false,
    }
  },
  methods: {
    reset_password() {
      this.reset = true
      firebase.auth().sendPasswordResetEmail(this.$root.user.email)
        .then(() => this.reset='success')
        .catch((e) => this.close)
    },
    close() {
      this.$emit('close')
      this.reset = false
    }
  }
}
</script>
<style>
.menu-top .item .icon, .menu-top .item .svg-icon  {
  width: 24px;
  height: 24px;
  color: rgba(0,0,0,0.25);
}
.menu-top .item .icon.disabled {
  color: rgba(0,0,0,0.05);
}
.mobile:not(.laptop) .menu-top .item .icon, .menu-top .item .svg-icon {
  width: 18px;
  height: 18px;
}
.menu-top .modal {
  position: fixed;
  width: 300px;
  background: var(--background);
  top: calc(50vh - 150px);
  left: calc(50vw - 150px);
  box-shadow: var(--box-shadow);
  border-radius: 12px;
  padding: 24px;
  z-index: 1000;
}
</style>
